import config from 'config';
import { ComponentProps, FC, ReactNode } from 'react';
import ReactInputMask from 'react-input-mask';

import styles from './styles.module.scss';

type PropTypes = {
  mask?: ComponentProps<typeof ReactInputMask>['mask'];
  children?: (props: any) => ReactNode;
} & Omit<ComponentProps<typeof ReactInputMask>, 'mask' | 'children'>;

const PhoneInput: FC<PropTypes> = ({ children, ...restProps }) => {
  const digitsOnly = (restProps.value ?? '').toString().replace(/\D/g, '');
  const hasDigit = digitsOnly.length > 0;

  const className = `ant-input ${styles.phoneInput} ${
    !hasDigit && styles.grayColor
  } ${restProps.className || ''}`;

  return (
    <ReactInputMask
      {...restProps}
      mask={config.UI.PHONE_NUMBER_MASK}
      className={className}
      children={children as any}
    />
  );
};

export default PhoneInput;
